import React from 'react';
import { Box, Grid, Paper, Typography, Radio } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SalesOverviewRenderer from './SalesOverviewRenderer';
import { SALES_OVERVIEW_TEMPLATES, SAMPLE_SALES_OVERVIEW } from './salesOverviewConstants';
import { DASHBOARD_COLORS } from '../dashboardStyles';

const SalesOverviewTemplatePicker = ({ value, onChange }) => (
  <Box>
    <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.9rem', mb: 0.25 }}>
      Sales overview template
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.25 }}>
      Preview matches your dashboard layout.
    </Typography>
    <Grid container spacing={1.25}>
      {SALES_OVERVIEW_TEMPLATES.map((tpl) => {
        const selected = value === tpl.id;
        return (
          <Grid item xs={12} sm={4} key={tpl.id}>
            <Paper
              elevation={0}
              onClick={() => onChange(tpl.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onChange(tpl.id);
                }
              }}
              sx={{
                cursor: 'pointer',
                border: `2px solid ${selected ? DASHBOARD_COLORS.accent : DASHBOARD_COLORS.border}`,
                borderRadius: 1.5,
                overflow: 'hidden',
                position: 'relative',
                transition: 'border-color 0.15s',
                '&:hover': {
                  borderColor: selected ? DASHBOARD_COLORS.accent : DASHBOARD_COLORS.textMuted,
                },
                '&:focus-visible': {
                  outline: `2px solid ${DASHBOARD_COLORS.accent}`,
                  outlineOffset: 2,
                },
              }}
            >
              {selected && (
                <CheckCircleIcon
                  sx={{
                    position: 'absolute',
                    top: 6,
                    right: 6,
                    zIndex: 2,
                    color: DASHBOARD_COLORS.accent,
                    fontSize: 20,
                    bgcolor: 'white',
                    borderRadius: '50%',
                  }}
                />
              )}
              <Box
                sx={{
                  height: 130,
                  overflow: 'hidden',
                  pointerEvents: 'none',
                  bgcolor: DASHBOARD_COLORS.bg,
                }}
              >
                <Box sx={{ transform: 'scale(0.48)', transformOrigin: 'top left', width: '208%' }}>
                  <SalesOverviewRenderer
                    template={tpl.id}
                    labels={SAMPLE_SALES_OVERVIEW.labels}
                    data={SAMPLE_SALES_OVERVIEW.data}
                    metrics={SAMPLE_SALES_OVERVIEW.metrics}
                    loading={false}
                    compact
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  px: 1,
                  py: 0.75,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                  borderTop: `1px solid ${DASHBOARD_COLORS.border}`,
                  bgcolor: DASHBOARD_COLORS.surface,
                }}
              >
                <Radio checked={selected} size="small" sx={{ p: 0 }} tabIndex={-1} />
                <Box minWidth={0}>
                  <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.8125rem', lineHeight: 1.2 }}>
                    {tpl.label}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                    {tpl.description}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  </Box>
);

export default SalesOverviewTemplatePicker;
